module.exports = __webpack_public_path__ + "img/440-african_proverbs_quotes.2c3c30f0.jpeg";